import React from "react"
import styled from "styled-components"
import { colors, fontWeight, scale } from "../../styles"

export interface Props {
	text: string
}

const StyledTag = styled.span`
	display: flex;
	justify-content: center;
	align-items: center;
	height: ${scale.px(4)};
	padding: 0 ${scale.px(2)};
	min-width: ${scale.px(7.5)};
	background-color: ${colors.navy};
	color: ${colors.white};
	font-size: ${scale.px(1.75)};
	font-weight: ${fontWeight.bold};
	text-transform: uppercase;
	letter-spacing: 1px;
	border-radius: ${scale.px(1)};
	overflow: hidden;
`

const Tag: React.FC<Props> = ({ text }) => {
	return <StyledTag>{text}</StyledTag>
}

export { Tag }
